import React from "react";
import ReactApexChart from "react-apexcharts";

import getChartColorsArray from "../../Components/Common/ChartsDynamicColor";

const RevenueCharts = ({ dataColors, series, dateList }) => {
  var linechartcustomerColors = getChartColorsArray(dataColors);
 
  var options = {
    chart: {
      height: 370,
      type: "line",
      toolbar: {
        show: false,
      }
    }, 
    stroke: {
      curve: "smooth",
      width: 2,
      dashArray: [0, 0, 3]
    },
    markers: {
      size: 3
    },
    xaxis: {
      categories: dateList,
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: [
      {
        title: {
          text: "Sales Amount($)"
        }
      }
    ],
    tooltip: {
      shared: true,
      intersect: false
    },
    grid: {
      borderColor: '#f1f1f1',
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 10
      }
    },
    legend: {
      show: true,
      position: 'bottom'
    },
    colors: linechartcustomerColors
  };
  
  return (
    <React.Fragment>
      <ReactApexChart 
        options={options}
        series={series}
        type="line"
        height="370"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

// 简化版的StoreVisitsCharts
const StoreVisitsCharts = ({ dataColors }) => {
  var chartDonutBasicColors = getChartColorsArray(dataColors);
  const series = [44, 55, 41, 17, 15];
  var options = {
    chart: {
      height: 333,
      type: "donut"
    },
    labels: ["Direct", "Social", "Email", "Other", "Referrals"],
    colors: chartDonutBasicColors,
    legend: {
      position: "bottom"
    },
    dataLabels: {
      enabled: false
    }
  };
  
  return (
    <React.Fragment>
      <ReactApexChart
        options={options}
        series={series}
        type="donut"
        height="333"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

export { RevenueCharts, StoreVisitsCharts };
